import React, {useEffect, useState} from "react";
import axios from 'axios';
import Swal from 'sweetalert2';
import {useNavigate} from 'react-router-dom';
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {baseUrl, ipAddress, userLocation, userName} from '../Univ.js'
function DonorRegister() {
    const navigate = useNavigate();
    const [errorMsg, seterrorMsg] = useState('');
    const [gender, setGender] = useState("male"); // set default value to "male"
    const [succesMsg, setsuccessMsg] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [donor, setDonor] = useState([]);
    const [DonateData, setDonateData] = useState([]);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [registerFormData, setRegisterFormData] = useState({
        "my_title": '',
        "donor": '',
        "age": '',
        "mobile": '',
        "email": '',
        "address": '',
        "gender": '',
        "aadhar": '',
        "weight": '',
        "height": '',
        "medical": '',
        "refered": '',
        "status": '',
        "addedby": '',
        "ip_add": '',
    });
    const handleInputChange = (event) => {
        setGender(event.target.value);
    };
    const inputHandler = (event) => {
        setRegisterFormData({
            ...registerFormData,
            [event.target.name]: event.target.value
        })
    };
    const submitHandler = (e) => {
        e.preventDefault();
        const formData = new FormData();
        const title = document.getElementById("title").value;
        const blood = document.getElementById("blood").value;
        formData.append('my_title', title);
        formData.append('donor', registerFormData.donor);
        formData.append('age', registerFormData.age);
        formData.append('gender', gender);
        formData.append('email', registerFormData.email);
        formData.append('mobile', registerFormData.mobile);
        formData.append('address', registerFormData.address);
        formData.append('bloodgroup', blood);
        formData.append('aadhar', registerFormData.aadhar);
        formData.append('weight', registerFormData.weight);
        formData.append('height', registerFormData.height);
        formData.append('refered', registerFormData.refered);
        formData.append('medical', registerFormData.medical);
        formData.append('status', '1');
        formData.append('addedby', userName);
        formData.append('ip_add', ipAddress);
        formData.append('location', userLocation);
        axios.post(baseUrl + 'donor-create/', formData)
            .then((response) => {
                if (response.status == 200 || response.status == 201) {
                    Swal.fire({
                        title: 'donor has been added.',
                        icon: 'success',
                        timer: 2000,
                        showConfirmButton: false
                    });
                    setRegisterFormData({
                        title: '',
                        donor: '',
                        age: '',
                        gender: '',
                        email: '',
                        aadhar: '',
                        medical: '',
                        mobile: '',
                        address: '',
                        refered: '',
                        status: '',
                        addedby: '',
                        ip_add: '',
                    });
                    setTimeout(() => {
                        window.location.href = '/add-donor/';
                    }, 2000);
                }
            })
            .catch(error => {
                console.log(error);
                Swal.fire(
                    'Error!',
                    'Failed to add donor. Please try again later.',
                    'error'
                );
            });
    };
    const handleDelete = (id) => {
        Swal.fire({
            title: 'Confirm',
            text: 'Are you Sure you want to delete this',
            icon: 'info',
            confirmButtonText: 'Continue',
            showCancelButton: true
        }).then((result) => {
            if (result.isConfirmed) {
                try {
                    axios.delete(baseUrl + 'delete-donor/' + id)
                        .then(function (response) {
                            Swal.fire('success', 'Data has been Deleted');
                            window.location.reload();
                        });
                } catch (error) {
                    Swal.fire('error', 'Data has not been deleted');
                }
            } else {
                Swal.fire('error', 'Data has not been deleted');
            }
        })
    }
    useEffect(() => {
        fetchData();
    }, []);
    function fetchData() {
        axios.get(`${baseUrl}donor-create/`)
            .then(response => {
                setDonor(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }
    const columns = [
        {
            field: 'donate', headerName: 'Donate',
            renderCell: (params) => {
                const donorId = params.row.id;
                return (
                    <button
                        type="button"
                        className="btn btn-success"
                        data-bs-toggle="modal"
                        data-bs-target="#response-esc-modal"
                        onClick={() => handleDonClick(donorId)}
                    >
                        Donate
                    </button>
                );
            },
            width: 80
        },
        {
            field: 'delete', headerName: 'Action',
            renderCell: (params) => (
                <button onClick={() => handleDelete(params.row.id)} className="btn btn-danger btn-sm ms-1">
                    <i className="fa-solid fa-trash-can"></i></button>
            ),
            width: 100
        },
        {field: 'donor', headerName: 'Donor Name', width: 140},
        {field: 'bloodgroup', headerName: 'Blood Group', width: 90},
        {field: 'age', headerName: 'Age', width: 50},
        {field: 'mobile', headerName: 'Mobile', width: 100},
        {field: 'email', headerName: 'Email', width: 100},
        {field: 'gender', headerName: 'Gender', width: 80},
        {field: 'address', headerName: 'Address', width: 160},
        {field: 'aadhar', headerName: 'Aadhar', width: 130},
        {field: 'medical', headerName: 'Medical', width: 150},
        {field: 'weight', headerName: 'Weight', width: 60},
        {field: 'height', headerName: 'Height', width: 60},
        {field: 'refered', headerName: 'Referred', width: 150},
    ];
    const handleDonClick = (donorId) => {
        const selectedData = donor.find(data => data.id == donorId);
        if (selectedData) {
            setDonateData({
                did: selectedData.id,
                donor: selectedData.donor,
                blood: selectedData.bloodgroup,
                age: selectedData.age,
                medical: selectedData.medical,
            });
        }
    };
    const handleDateChange = (date) => {
        if (date) {
            const dateString = date.toISOString().slice(0, 10);
            const dateObj = new Date(dateString);
            dateObj.setHours(0, 0, 0, 0);
            setSelectedDate(dateObj);
        }
    };
    const handleDonChange = (event) => {
        setDonateData((prevData) => ({
            ...prevData,
            [event.target.name]: event.target.value
        }));
    };
    const formSubmitesc = (e) => {
        e.preventDefault();
        const did = document.getElementById('did');
        const didValue = did.value;
        const donate_on = selectedDate.toISOString().slice(0, 10);
        const _formData = new FormData();
        _formData.append('donor', didValue);
        _formData.append('blood', DonateData.blood);
        _formData.append('donate_on', donate_on);
        _formData.append('unit', DonateData.unit);
        _formData.append('addedby', userName);
        _formData.append('ip_add', ipAddress);
        _formData.append('location', userLocation);
        axios.post(`${baseUrl}donate-update/`, _formData)
            .then(response => {
                if (response.status == 200 || response.status == 201) {
                    const tkData = new FormData();
                    tkData.append("donate", DonateData.unit);
                    axios.post(`${baseUrl}blood-update/` + DonateData.blood + '/', tkData)
                        .then(response => {
                        })
                    Swal.fire({
                        title: 'Blood Donated and Stock Updated.',
                        icon: 'success',
                        timer: 2000,
                        showConfirmButton: false
                    });
                    setTimeout(() => {
                        window.location.href = '/add-donor/';
                    }, 2000);
                }
            })
            .catch(error => {
                console.log(error);
                Swal.fire(
                    'Error!',
                    'Failed to Send Response. Please try again later.',
                    'error'
                );
            });
    };
    const buttonEnable = (registerFormData.donor != '') && (registerFormData.age != '') && (registerFormData.mobile != '')
    return (
        <section className="container mt-4">
            <div className="row">
                <div className="col-md-8 col-12">
                    <div className='card'>
                        <h4 className='card-header text-center'>New Donor Registration</h4>
                        <div className='card-body'>
                            <p className="text-muted"><strong>Note:</strong>All are Mandatory Fields</p>
                            {succesMsg && <p className="text-success">{succesMsg}</p>}
                            {errorMsg && <p className="text-danger">{errorMsg}</p>}
                            <form>
                                <div className="row">

                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="Role" className="form-label">Donor Title</label>
                                        <select className="form-control" value={registerFormData.title}
                                                onChange={inputHandler}
                                                name="title" id="title">
                                            <option value="Mr">Mr</option>
                                            <option value="Mrs">Mrs</option>
                                            <option value="Master">Master</option>
                                            <option value="Dr">Dr</option>
                                            <option value="Baby">Baby</option>
                                            <option value="Ms">Ms</option>
                                        </select>
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="Role" className="form-label">Donor Name</label>
                                        <input type="text" placeholder="Donor Name" className="form-control"
                                               name="donor" value={registerFormData.donor} onChange={inputHandler}/>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="Age" className="form-label">Age</label>
                                        <input type="text" placeholder="Age" className="form-control"
                                               name="age" value={registerFormData.age} onChange={inputHandler}/>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="Email" className="form-label">Email</label>
                                        <input type="mail" placeholder="Email" className="form-control"
                                               name="email" value={registerFormData.email} onChange={inputHandler}/>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="Mobile" className="form-label">Mobile</label>
                                        <input type="number" maxLength={10} placeholder="Mobile"
                                               className="form-control"
                                               name="mobile" value={registerFormData.mobile} onChange={inputHandler}/>
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="Address" className="form-label">Address</label>
                                        <input type="text" placeholder="Address" className="form-control"
                                               name="address" value={registerFormData.address} onChange={inputHandler}/>
                                    </div>
                                </div>
                                <div className="row">

                                    <div className="col-md-5 mb-3">
                                        <label htmlFor="Gender" className="form-label">Gender</label>
                                        <label className="radio-inline">

                                            <input type="radio" name="gender" value="male" checked={gender === "male"}
                                                   onChange={handleInputChange}/> Male
                                        </label>
                                        <label className="radio-inline">
                                            <input type="radio" name="gender" value="female"
                                                   checked={gender === "female"}
                                                   onChange={handleInputChange}/> Female
                                        </label>
                                        <label className="radio-inline">
                                            <input type="radio" name="gender" value="transgender"
                                                   checked={gender === "transgender"}
                                                   onChange={handleInputChange}/> Transgender
                                        </label>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="Aaadhar" className="form-label">Aaadhar</label>
                                        <input type="number" placeholder="Aaadhar" className="form-control"
                                               maxLength={16}
                                               name="aadhar" id="aadhar" value={registerFormData.aadhar}
                                               onChange={inputHandler}/>
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label htmlFor="Refered" className="form-label">Referred By</label>
                                        <input type="text" className="form-control" value={registerFormData.refered}
                                               onChange={inputHandler}
                                               name="refered" id="refered"/>

                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4 mb-3">
                                        <label htmlFor="Blood Group" className="form-label">Blood Group</label>
                                        <select className="form-control"
                                                value={registerFormData.blood}
                                                onChange={inputHandler}
                                                name="blood" id="blood" readOnly>
                                            <option>Select Blood Group</option>
                                            <option value="O+">O+</option>
                                            <option value="O-">O-</option>
                                            <option value="B+">B+</option>
                                            <option value="B-">B-</option>
                                            <option value="A+">A+</option>
                                            <option value="A-">A-</option>
                                            <option value="AB+">AB+</option>
                                            <option value="AB-">AB-</option>
                                        </select>
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label htmlFor="Weight" className="form-label">Weight</label>
                                        <input type="number" maxLength={10} placeholder="Weight"
                                               className="form-control"
                                               name="weight" id="weight"
                                               onChange={inputHandler}/>
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label htmlFor="Height" className="form-label">Height</label>
                                        <input type="number" maxLength={10} placeholder="Height"
                                               className="form-control"
                                               name="height" id="height"
                                               onChange={inputHandler}/>
                                    </div>
                                </div>
                                <div className="row">
                                    <label htmlFor="Medical History" className="form-label">Medical History</label>
                                    <div className="col-md-12 mb-3">
                        <textarea className="no-comma" tabIndex={0} name="medical" id="medical"
                                  value={registerFormData.medical}
                                  onChange={inputHandler} cols="50" rows="3">
                        </textarea>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12 text-center">
                                        <button type="button" disabled={!buttonEnable} onClick={submitHandler}
                                                className="btn btn-success">Register
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="response-esc-modal" tabIndex="-1" aria-labelledby="response-esc-modal-label"
                 aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="response-esc-modal-label">Blood Donation</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal"
                                    aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <form>
                                <label className="form-label">Donor ID:</label>
                                <input type="hidden" className="form-control" id="did" name="did"
                                       value={DonateData.did}/>
                                <input type="hidden" className="form-control" id="blood" name="blood"
                                       value={DonateData.blood}/>
                                <span className="form-control">{DonateData.did}</span>

                                <label className="form-label">Donor Name:</label>
                                <span className="form-control">{DonateData.donor}</span>

                                <label className="form-label">Age:</label>
                                <span className="form-control">{DonateData.age}</span>

                                <label>Blood Group: </label>
                                <span className="form-control">{DonateData.blood}</span>

                                <label>Unit (ml): </label>
                                <input type="number" className="form-control" id="unit" name="unit"
                                       onChange={handleDonChange}/>
                                <label className="form-label">Transfusion Date:</label>
                                <DatePicker selected={selectedDate || new Date()} onChange={handleDateChange}
                                            dateFormat="yyyy-MM-dd"/>
                                <button type="button" onClick={formSubmitesc} className="btn btn-primary mt-4">
                                    Submit
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{height: "100%", width: "100%"}} className="mt-5">
                <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i
                    className="fa-solid fa-hand-holding-droplet"
                    aria-hidden="true" style={{color: 'red'}}></i> Donor List</h3>
                <DataGrid className="mt-4"
                          sx={{
                              boxShadow: 4,
                              border: 4,
                              borderColor: 'primary.light',
                              '& .MuiDataGrid-cell:hover': {
                                  color: 'primary.main',
                              },
                          }}
                          pageSize={28}
                          rows={donor}
                          columns={columns}
                          components={{
                              Toolbar: GridToolbar,
                          }}
                          autoHeight
                />
            </div>
        </section>
    );
}
export default DonorRegister;
